<template>
  <v-card :elevation="$vuetify.breakpoint.xsOnly ? 0 : ''" class="mb-4">
    <v-card-title class="subtitle-1 text-uppercase font-weight-medium">{{ $t('quotations.basics.card_basics') }}</v-card-title>
    <v-card-text>
      <v-row dense>
        <v-col cols="12" sm="4">
          <v-autocomplete
            v-model="quotation.authorUserId"
            :items="users"
            :item-text="userName"
            item-value="id"
            :label="$t('quotations.basics.author')"
            :disabled="saving"
            outlined
            dense
            hide-details
          >
            <template v-slot:prepend><v-icon>mdi-account-edit-outline</v-icon></template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <date-picker
            :date="quotation.request.desiredStart"
            :label="$t('quotations.basics.desired_start')"
            :saving="saving"
            :input-styles="{ outlined: true, dense: true }"
            clearable
            @change="v => $set(quotation.request, 'desiredStart', v)"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <date-picker
            :date="quotation.request.plannedEnd"
            :label="$t('quotations.basics.planned_end')"
            :saving="saving"
            :input-styles="{ outlined: true, dense: true }"
            clearable
            @change="v => $set(quotation.request, 'plannedEnd', v)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import DatePicker from '@/components/DatePicker';

export default {
  name: 'QuotationBasicsTab',
  components: { DatePicker },
  props: {
    quotation: { type: Object, required: true },
    users: { type: Array, default: () => [] },
    saving: { type: Boolean, default: false },
  },
  methods: {
    userName(u) {
      return `${u.firstName} ${u.lastName}`;
    },
  },
};
</script>
